/**
 * 動的グループのルール(JSON)を扱う小物。
 *
 * ルールは `{"op": "and"|"or", "conds": [ {field, cmp, value} | 入れ子 ]}`。
 * 画面(`GroupRuleEditor.tsx`)と呼び出し側の両方が使うので、**コンポーネントとは
 * 別のファイル**に置く(1 ファイル 1 コンポーネントにして Fast Refresh を保つ)。
 */
import type { GroupCond, GroupRuleNode } from "../../lib/api";

export function isNode(x: GroupCond | GroupRuleNode): x is GroupRuleNode {
  return typeof x === "object" && x !== null && "conds" in x;
}

/** 空のルール(一番外側は必ず and/or のグループ)。 */
export function emptyRule(): GroupRuleNode {
  return { op: "and", conds: [] };
}

/** 条件の総数(入れ子の中も足す)。上限に達したら追加ボタンを止める。 */
export function condCount(node: GroupRuleNode): number {
  return node.conds.reduce((n, c) => n + (isNode(c) ? condCount(c) : 1), 0);
}
